// Scopes and sources carry a colour *name*, not CSS: the server stores
// "violet", the client owns what that looks like. Every class is written out in
// full because Tailwind only keeps what it can see — `bg-${color}-100` would
// compile to nothing.

export type ColorName = keyof typeof PALETTE;

export const PALETTE = {
  zinc: { chip: "bg-zinc-100 text-zinc-700", dot: "bg-zinc-500", hex: "#71717a" },
  blue: { chip: "bg-blue-100 text-blue-700", dot: "bg-blue-500", hex: "#3b82f6" },
  violet: { chip: "bg-violet-100 text-violet-700", dot: "bg-violet-500", hex: "#8b5cf6" },
  teal: { chip: "bg-teal-100 text-teal-700", dot: "bg-teal-500", hex: "#14b8a6" },
  amber: { chip: "bg-amber-100 text-amber-700", dot: "bg-amber-500", hex: "#f59e0b" },
  emerald: { chip: "bg-emerald-100 text-emerald-700", dot: "bg-emerald-500", hex: "#10b981" },
  rose: { chip: "bg-rose-100 text-rose-700", dot: "bg-rose-500", hex: "#f43f5e" },
  orange: { chip: "bg-orange-100 text-orange-700", dot: "bg-orange-500", hex: "#f97316" },
  cyan: { chip: "bg-cyan-100 text-cyan-700", dot: "bg-cyan-500", hex: "#06b6d4" },
  lime: { chip: "bg-lime-100 text-lime-700", dot: "bg-lime-500", hex: "#84cc16" },
  fuchsia: { chip: "bg-fuchsia-100 text-fuchsia-700", dot: "bg-fuchsia-500", hex: "#d946ef" },
  indigo: { chip: "bg-indigo-100 text-indigo-700", dot: "bg-indigo-500", hex: "#6366f1" },
} as const;

export const DEFAULT_COLOR: ColorName = "zinc";

// A colour the server sent that this build doesn't know about still has to
// render, so unknown names fall back rather than crash a list row.
export function colorOf(name: string | undefined) {
  return PALETTE[name as ColorName] ?? PALETTE[DEFAULT_COLOR];
}
